import { ElementRef, ViewChild, Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/app.states';
import { LogOut } from '@app/store/actions/auth.actions';
import { Notification } from '@app/shared';
import { NGXLogger } from 'ngx-logger';
import { User } from '../../models/user';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: [ './navbar.component.scss' ]
})
export class NavbarComponent implements OnInit {

  crumbActive:boolean;
  menuOpen:boolean = true;
  menuVisible:boolean = true;
  isLoading:boolean = true;
  showAnim:boolean = true;
  isMenuShown:boolean = false;
  isNotificationsShown:boolean = false;
  repeatedMessages = [];

  @Input() navlinks;
  @Input() type:string;
  @Input() messages:Notification[];
  @Input() user:User;

  @Output() clearMsgClick : EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('navbarToggle') toggle: ElementRef;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(!this.eRef.nativeElement.contains(event.target)) {
      this.isNotificationsShown = false;
    }
  }

  constructor(
    private router: Router,
    private location: Location,
    //private userService : UserService,
    private store: Store<AppState>,
    private eRef: ElementRef,
    private logger: NGXLogger)
    // public productService : ProductService)
    {

        router.events.subscribe((val) => {
        // see also
        if(val instanceof NavigationStart){
          let tmpLoc = val.url.indexOf('detail');
          this.crumbActive = tmpLoc > -1?true:false;

          this.menuVisible = val.url.indexOf('login') > -1?false:true;
          // hide the dropdown
          //let classList = this.toggle.nativeElement.classList;

          // if the classlist contains 'collapse' then hide it
          // if(classList[1] !== 'collapsed'){
          //   let event = new MouseEvent('click', {bubbles: true});
          //   this.toggle.nativeElement.dispatchEvent(event);
          // }
        }

        //this.product = this.productSerivce.product;

    });

    //this.product = this.productSerivce.product;
  }

  ngOnInit(): void {
    setTimeout(_ => this.isLoading = false,200);
    //setTimeout(_ => this.showAnim = false,3000);
    this.logger.debug(this.messages, ' messages');
  }

  ngAfterViewInit(){
    //  this.logger.debug(this.navlinks);
  }

  showSettings():void{
    this.router.navigate(['/account']);
  }
  showMenu():Boolean{
    return (this.router.url != "/login");
  }
  search():void{
    this.router.navigate(['/search']);
  }

  getLink(val:string):string{
    return `main/${val}`;
  }
  getNotificationCount():number{
    let repeat = this.messages.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.code === value.code
      ))
    )
    this.repeatedMessages = repeat;
    let msgs = this.repeatedMessages.filter(val => {return val.isRead === false});
    return msgs.length;
    // let msgs = this.messages.filter(val => {return val.isRead === false});
    // return repeat.length;
  }
  onNavClick(val:string):void{
    this.router.navigate([`main/${val}`]);
  }
  onNotificationClick(val:Notification):void{
    val.isRead = true;
    console.log(val);
    if(val.plan){
      this.router.navigate(['main/projects/', val.plan]);
    }
    if(val.url){
      window.open(val.url, "_blank");
    }

  }
  // onIngestClick():void{
  //   const payload={};
  //   this.logger.debug('ingest click')
  //   this.store.dispatch(new IngestOffers(payload));
  // }
  public clearNotifications():void{
    this.clearMsgClick.emit(null);
  }

  logout():void{
    this.router.navigate(['/auth/logout']);

    // const payload = {user:this.user}
    // this.store.dispatch(new LogOut(payload));

    // this.userService.logout()
    //   .subscribe(loggedIn => {
    //
    //     if(!loggedIn)
    //       this.router.navigate(['/auth/login']);
    //   })
  }

  goBack(): void {
    this.location.back();
  }
  toggleClick(e:any):void{
    this.menuOpen = !this.menuOpen;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/navbar/navbar.component.ts